import { Injectable, inject } from '@angular/core';
import { AuthenticationActions } from '@navfleet/client/authentication/domain/data-access';
import { AppActions } from '@navfleet/client/core/app';
import { logDebug } from '@navfleet/client/shared/util/log';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, concatMap, map, take, takeUntil } from 'rxjs/operators';
import { ReferenceDataUnitsApi } from '../api/reference-data-units.api';
import * as referenceDataUnitActions from './reference-data-units.actions';
import * as fromReferenceDataUnits from './reference-data-units.reducer';
import { backendDataUnitsLoadingOrLoaded } from './reference-data-units.selectors';

@Injectable()
export class ReferenceDataUnitsEffects {
    private readonly actions$ = inject(Actions);
    private readonly unitsApi = inject(ReferenceDataUnitsApi);
    private readonly store$ = inject<Store<fromReferenceDataUnits.State>>(Store);

    public readonly loadBackendDataUnits$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthenticationActions.loginSuccess),
            concatMap(() =>
                this.store$.pipe(
                    select(backendDataUnitsLoadingOrLoaded),
                    take(1),
                    concatMap(([loading, loaded]) => {
                        if (loaded || loading) {
                            return EMPTY;
                        }
                        return this.unitsApi.getBackendDataUnits().pipe(
                            take(1),
                            map((backendDataUnits) => {
                                logDebug(
                                    'ReferenceDataUnitsEffects',
                                    'loadBackendDataUnits',
                                    'backendDataUnits',
                                    backendDataUnits
                                );
                                return referenceDataUnitActions.loadBackendDataUnitsSuccess({ backendDataUnits });
                            }),
                            catchError((error) =>
                                of(
                                    referenceDataUnitActions.loadBackendDataUnitsFailure({
                                        errorMessage: error,
                                    })
                                )
                            ),
                            takeUntil(this.actions$.pipe(ofType(AppActions.applicationClosed)))
                        );
                    })
                )
            )
        )
    );
}
